export default "__VITE_ASSET__CH_FeYU7__"